import z from "zod";

export const getServiceSchema = z.object({
	serviceId: z.uuid("Service ID must be a valid UUID"),
});

export type GetServiceSchema = z.infer<typeof getServiceSchema>;
